export default "__VITE_ASSET__61fdf646__"